export default __webpack_public_path__ + "static/media/back.11b401a9.svg";